var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3846 2H11.6154C11.2755 2 11 2.28491 11 2.63636V15.3636C11 15.7151 11.2755 16 11.6154 16H14.3846C14.7245 16 15 15.7151 15 15.3636V2.63636C15 2.28491 14.7245 2 14.3846 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38462 2H3.61538C3.27552 2 3 2.28491 3 2.63636V15.3636C3 15.7151 3.27552 16 3.61538 16H6.38462C6.72448 16 7 15.7151 7 15.3636V2.63636C7 2.28491 6.72448 2 6.38462 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.fcdbde987206ff73cb4ec32010ce974f.svg";
export { ForwardRef as ReactComponent };